import { Alert, Box, Button, Modal, Snackbar } from '@mui/material'
import Form from 'components/RouteWizard/Form'
import Input from 'components/RouteWizard/Input'
import React, { createContext, useContext, useState } from 'react'
import defaultValues from './defaultValues'
import schema from './schema'

type TwoFactorData = {
  startTwoFactor: (contactNumber: string) => void
  isVerified: boolean
}

type ProvideTwoFactorProps = {
  children: React.ReactNode
}

const TwoFactorContext = createContext<TwoFactorData>({
  isVerified: false,
  startTwoFactor: () => {},
})

export default function useTwoFactor(): TwoFactorData {
  return useContext(TwoFactorContext)
}

export function ProvideTwoFactor({ children }: ProvideTwoFactorProps) {
  const [isVerified, setIsVerified] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [contactNumber, setContactNumber] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const verifyCode = (code: string) => {
    if (code === '1234') {
      return {
        status: 200,
        data: {
          token:
            'eyJhbGciOiJSUzI1NiIsImtpZCI6IjI3NTk0QzMwMjMwMkY2MjI1MzkyNzNBRjYzRkEzMjNCREZCNDcxQ0VSUzI1NiIsInR5cCI6ImF0K2p3dCIsIng1dCI6IkoxbE1NQ01DOWlKVGtuT3ZZX295TzktMGNjNCJ9.eyJuYmYiOjE2NDYzODY4MjAsImV4cCI6MTY0NjQxNTYyMCwiaXNzIjoiaHR0cHM6Ly9qeXJuZXktYXBpLXVzZXJzLWRldi5henVyZXdlYnNpdGVzLm5ldCIsImF1ZCI6WyJib29raW5ncyIsImNoYXVmZmVyQm9va2luZ1BvbGljaWVzIiwiY2hhdWZmZXJQb2xpY2llcyIsImNsaWVudHMiLCJjb2FjaEJvb2tpbmdQb2xpY2llcyIsImNvYWNoUG9saWNpZXMiLCJkcml2ZXJMb2NhdGlvbnMiLCJpbnZvaWNlcyIsImxvY2F0aW9uU2VydmljZXMiLCJvY2Vsb3QiLCJxdW90ZXMiLCJzdXBwbGllckdyb3VwcyIsInN1cHBsaWVyT3BlcmF0aW9ucyIsInN1cHBsaWVycyIsInRheGlCb29raW5nUG9saWNpZXMiLCJ0YXhpUG9saWNpZXMiLCJ0YXhpUmF0ZXMiLCJ0YXhpcyIsInRyYXZlbFBvbGljaWVzIiwidXNlcnMiXSwiY2xpZW50X2lkIjoianlybmV5LndlYmFwcCIsInN1YiI6IjEiLCJhdXRoX3RpbWUiOjE2NDYzODY4MjAsImlkcCI6ImxvY2FsIiwiZW1haWwiOiJqeXJuZXlBZG1pbkBqeXJuZXkuY29tIiwiVXNlcklkIjoiMSIsIkNsaWVudElkIjoiMSIsIkFwcGxpY2F0aW9uVGhlbWUiOiJKeXJuZXkiLCJTdXBwbGllcklkIjoiIiwiVHJhdmVsUG9saWN5SWQiOiItMSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6Ikp5cm5leUFkbWluIiwianRpIjoiMUQ5RTJBOTk5MEI2NTM4MDdGMzhCMTkxREJCQTU2MjciLCJpYXQiOjE2NDYzODY4MjAsInNjb3BlIjpbImJvb2tpbmdzIiwiY2hhdWZmZXJCb29raW5nUG9saWNpZXMiLCJjaGF1ZmZlclBvbGljaWVzIiwiY2xpZW50cyIsImNvYWNoQm9va2luZ1BvbGljaWVzIiwiY29hY2hQb2xpY2llcyIsImRyaXZlckxvY2F0aW9ucyIsImVtYWlsIiwiaW52b2ljZXMiLCJsb2NhdGlvblNlcnZpY2VzIiwib2NlbG90Iiwib3BlbmlkIiwicHJvZmlsZSIsInF1b3RlcyIsInN1cHBsaWVyR3JvdXBzIiwic3VwcGxpZXJPcGVyYXRpb25zIiwic3VwcGxpZXJzIiwidGF4aUJvb2tpbmdQb2xpY2llcyIsInRheGlQb2xpY2llcyIsInRheGlSYXRlcyIsInRheGlzIiwidHJhdmVsUG9saWNpZXMiLCJ1c2VycyJdLCJhbXIiOlsicHdkIl19.BuwlOjQkRncF-UUea3LIrZNzcsfKwjBQfmAtzcuBCYw7NNSPgeUV0vf7_7ngsacyUioxLtAblJVQSjKJ_hmG4Jif364laWso_aZByYhpU6LTRK6Klq3pu--yxqXfmKNV1gYOwalfXdF6s8dscORclmoyDRPQmaM4d-NUEsvRkHiZHQBY3D7q0P7s4sMCErZsljOErgnqHoBSKYWY0G1zLYGa08ghHniGPIXX7VUHmPKRBl2fjXQ8Ln3jPLwS2H-uxGWzOwpxI7pKNgJsQu-Gug1kc0sZ70ZLb3s9fNpA16-PwtF-Xiq7X0AhP2h170_IPCmwYVEh83lBejg9DsDikw',
        },
      }
    } else {
      return {
        status: 401,
      }
    }
  }

  const authenticate = (data: any) => {
    setError(null)
    const code = Object.values(data.authCode).reverse().join('')

    const resp = verifyCode(code)
    if (resp.status === 200) {
      setIsVerified(true)
      setModalVisible(false)
      localStorage.setItem('user', resp.data.token)
    } else {
      setError('Authorization failed.')
    }
  }

  return (
    <TwoFactorContext.Provider
      value={{
        startTwoFactor: (contactNumber) => {
          setContactNumber(contactNumber)
          setModalVisible(true)
        },
        isVerified,
      }}
    >
      <>
        <Modal
          open={modalVisible}
          aria-labelledby="two factor modal"
          aria-describedby="modal for booking flow auth"
        >
          <Box
            component="div"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: 360,
              backgroundColor: '#ffffff',
              boxShadow: 24,
              padding: '30px',
              textAlign: 'center',
            }}
          >
            <Box
              component="p"
              sx={{
                fontWeight: 'bold',
                fontSize: '18px',
                marginBottom: '30px',
              }}
            >
              Please authenticate your travel purchase.
            </Box>
            <Box component="p">
              An SMS has been sent to {contactNumber} with a 4 digit code.
              Please enter it below within the next 10 minutes
            </Box>
            <Box
              component="div"
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                marginTop: '20px',
                paddingBottom: '30px',
              }}
            >
              <Box
                component="p"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '16px',
                  margin: 0,
                  padding: 0,
                }}
              >
                Code:
              </Box>
              <Form
                schema={schema}
                onSubmit={authenticate}
                defaultValues={defaultValues}
                showControls={false}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '5px',
                  margin: 0,
                  padding: 0,
                }}
                formId="miniBookingAuth"
              >
                <Input
                  name={`authCode.one`}
                  inputProps={{
                    inputMode: 'numeric',
                    minLength: 1,
                    maxLength: 1,
                  }}
                />
                <Input
                  name={`authCode.two`}
                  inputProps={{
                    inputMode: 'numeric',
                    minLength: 1,
                    maxLength: 1,
                  }}
                />
                <Input
                  name={`authCode.three`}
                  inputProps={{
                    inputMode: 'numeric',
                    minLength: 1,
                    maxLength: 1,
                  }}
                />
                <Input
                  name={`authCode.four`}
                  inputProps={{
                    inputMode: 'numeric',
                    minLength: 1,
                    maxLength: 1,
                  }}
                />
              </Form>
            </Box>
            <Button type="submit" form={'miniBookingAuth'}>
              Submit
            </Button>
          </Box>
        </Modal>
        {children}
        <Snackbar open={error ? true : false} autoHideDuration={3000}>
          <Alert severity="error">{error}</Alert>
        </Snackbar>
      </>
    </TwoFactorContext.Provider>
  )
}
